import { ReactComponent as BgImg } from '../../assets/LeftSideBgLogo.svg';
import { Box, Button, Typography, styled } from "@mui/material";

export const StyledContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#FFFFFF',
});

export const StyledBgImg = styled(BgImg)({
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: '45vh',
    width: 'auto',
})

export const StyledImage = styled('img')({
    width: 'auto',
    height: '4vh',
    position: 'absolute',
    top: 30,
    left: 35,
});

export const StyledTypo = styled(Typography)({
    color: '#000000',
    fontSize: '2vh',
    fontWeight: 600,
    marginBottom: '5vh',
    userSelect: "none"
})

export const StyledButton = styled(Button)(({ theme }) => ({
    ...theme.typography.button,
    height: '5vh',
    width: '17.5vh',
    backgroundColor: '#788BF9',
    fontSize: '2vh',
    fontWeight: 700,
    color: '#FFFFFF',
    '&:hover': {
        backgroundColor: '#788BF9',
    },
    '&:disabled': {
        color: 'white',
        backgroundColor: '#DADEEA'
    },
    textTransform: 'none',
    borderRadius: '5px',
    marginTop: '1.5vh'
}));

export const CastContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& input::placeholder': {
        userSelect: 'none',
    },
})

export const StyledInput = styled('input')({
    height: '4.6vh',
    width: '17.1vh',
    border: 'none',
    backgroundColor: '#F4F5FF',
    color: '#434444',
    borderRadius: '5px',
    textAlign: 'center',
    fontSize: '2vh',
    fontWeight: 600,
    outline: 'none',
    '&::placeholder': {
        color: '#BAC3FF',
        textAlign: 'center',
    },
})

export const ErrorTypo = styled(Typography)({
    color: '#FE6F6F',
    fontSize: '1.5vh',
    fontWeight: 600,
    marginBottom: '0.2vh',
    marginTop: '0.5vh'
})
